import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control } from 'react-redux-form';
import SelectComponent from './SelectComponent';

import {
  FormGroup,
  Col,
  ControlLabel,
  FormControl
} from 'react-bootstrap';

export default class AWSSelectorComponent extends React.Component {
  static propTypes = {
    region: PropTypes.string.isRequired,
    account: PropTypes.string.isRequired,
    allRegions: PropTypes.arrayOf(PropTypes.string).isRequired,
    allAccounts: PropTypes.arrayOf(PropTypes.string).isRequired,
    grandTotals: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
  }

  render() {
    const {
      account,
      region,
      allAccounts,
      allRegions,
      grandTotals,
      onSubmit
    } = this.props;

    const initialState =
    {
      region: region,
      account: account
    }
  ;

    return (
      <div>
        <LocalForm
          id="aws-refresh-form"
          model="refresh"
          onChange={onSubmit}
          initialState={initialState}
        >
          <FormGroup>
            <Col md={2}>
              <ControlLabel>Grand Total(Yesterday):</ControlLabel>
              <Control.custom
                id="grand-total-yesterday"
                model="."
                component={FormControl}
                className="aws-form-control"
                type="text"
                readOnly
                value={grandTotals['grandTotalYesterday']}
              />
            </Col>
            <Col md={2}>
              <ControlLabel>Grand Total(Annualized):</ControlLabel>
              <Control.custom
                id="grand-total-annualized"
                model="."
                component={FormControl}
                className="aws-form-control"
                type="text"
                readOnly
                value={grandTotals['grandTotalAnnualized']}
              />
            </Col>
            <Col md={2} mdOffset={2}>
              <ControlLabel>
                AWS Account:
              </ControlLabel>
              <Control.custom
                id="account-input"
                model=".account"
                component={SelectComponent}
                className="form-control"
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  return {
                    options: allAccounts,
                    selected: modelValue,
                    onChange: d => onChange(d)
                  };
                }}
              />
            </Col>
            <Col md={2}>
              <ControlLabel>
                AWS Region:
              </ControlLabel>
              <Control.custom
                id="region-input"
                model=".region"
                component={SelectComponent}
                className="form-control"
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  return {
                    options: allRegions,
                    selected: modelValue,
                    onChange: d => onChange(d)
                  };
                }}
              />
            </Col>
          </FormGroup>
        </LocalForm>
      </div>
    ); }
}


// WEBPACK FOOTER //
// src/Components/AWSSelectorComponent.jsx